/**
 * Decision progress for a run, as the guided flow needs it.
 *
 * Pure and separate from the hook that feeds it, because the counting rule is
 * the part worth pinning: "decided" means every cell the policy put in the
 * REVIEW lane carries a decision — not that some decision exists somewhere.
 * Counting any recorded decision as progress would tick the step for someone
 * who decided one field out of forty.
 *
 * Cells outside the review lane are excluded by construction: an `auto` cell is
 * backfilled by approved policy and needs no call, and an `ineligible` one
 * cannot be decided at all because the reference has no value to restore.
 */

import { cellId, type CellClassification, type RecoveryDecision } from "../../engine/decisions";

export type DecisionProgress = { awaiting: number; decided: number };

export function countDecisionProgress(
  cells: CellClassification[],
  resolved: Map<string, RecoveryDecision>
): DecisionProgress {
  let awaiting = 0;
  let decided = 0;
  for (const cell of cells) {
    if (cell.lane !== "review") continue;
    awaiting++;
    if (resolved.has(cellId(cell.recordKey, cell.field))) decided++;
  }
  return { awaiting, decided };
}
